import { appConfig } from '@ll-platform/frontend/config/app.config';
import type { FeatureFlags } from '@ll-platform/frontend/config/featureFlags/featureFlags';

export const featureFlagsQueryKey = 'feature-flags';

export const featureFlagOverrides: Partial<FeatureFlags> =
  appConfig.REACT_APP_FEATURE_FLAG_OVERRIDES ?? {};
